module.exports = __webpack_public_path__ + "static/11-automated-vulnerability-scans-d57bd8adb5b3e1e4e7a2eaf66a129b48.jpg";